<template>
  <iColumn gap="standard" width="fill">
    <iRow
      v-for="(entry, entryIndex) in entries"
      :key="entryIndex"
      gap="standard"
      vertical-align="middle"
      wrap="nowrap"
      width="fill"
    >
      <iColumn width="fill">
        <iTextInput
          :model-value="entry"
          :placeholder="field.placeholder || ''"
          width="fill"
          @update:model-value="updateEntry(entryIndex, $event)"
        />
      </iColumn>
      <iButton
        v-if="entries.length > 1"
        variant="tertiary"
        size="small"
        width="hug"
        @click="removeEntry(entryIndex)"
      >
        Remove
      </iButton>
    </iRow>

    <iButton
      v-if="canAddMore"
      variant="secondary"
      width="fill"
      @click="addEntry"
    >
      {{ addLabel }}
    </iButton>
  </iColumn>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useQuestionnaireStore } from "@/stores/questionnaire-store";

export default {
  name: "QuestionnaireRepeaterText",
  props: {
    sectionKey: {
      type: String,
      required: true,
    },
    field: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState(useQuestionnaireStore, ["responseData"]),
    entries() {
      const list = this.responseData[this.sectionKey][this.field.key];
      if (Array.isArray(list) && list.length > 0) {
        return list;
      }
      return [""];
    },
    addLabel() {
      return this.field.repeater_add_label || "+ Add another";
    },
    canAddMore() {
      const max = this.field.repeater_max || 0;
      if (max === 0) {
        return true;
      }
      return this.entries.length < max;
    },
  },
  methods: {
    ...mapActions(useQuestionnaireStore, [
      "addRepeaterEntry",
      "removeRepeaterEntry",
      "setRepeaterEntryValue",
    ]),
    updateEntry(entryIndex, newValue) {
      this.setRepeaterEntryValue(this.sectionKey, this.field.key, entryIndex, newValue);
    },
    addEntry() {
      this.addRepeaterEntry(this.sectionKey, this.field.key);
    },
    removeEntry(entryIndex) {
      this.removeRepeaterEntry(this.sectionKey, this.field.key, entryIndex);
    },
  },
};
</script>
